// Scores
export const titleScoreWeights = [
  30, // Target Keyword Included
  30, // Length
  20, // Appearance
  20, // Reptition
];

// Scores
export const titleScoreWeightsWithCompetitor = [
  25, // Target Keyword Included
  25, // Length
  15, // Appearance
  15, // Reptition
  20, // Uniqueness
];

// Title Length Helper
export const titleLengthHelper = (charCount, wordCount) => {
  if (charCount < 25 || charCount > 75) {
    let score = 0;
    if (charCount < 25) {
      score = 20 * (charCount / 35);
    }
    if (charCount > 75) {
      score = 20 * (65 / charCount);
    }

    return {
      score: 35,
      percentage: score,
      charCount: charCount,
      wordCount: wordCount,
    };
  }
  if (
    (charCount >= 25 && charCount <= 34) ||
    (charCount >= 66 && charCount <= 75)
  ) {
    let score = 0;
    if (charCount >= 25 && charCount <= 34) {
      score = 60 * (charCount / 35);
    }
    if ((charCount) => 66 && charCount <= 75) {
      score = 60 * (65 / charCount);
    }
    return {
      score: 70,
      percentage: score,
      charCount: charCount,
      wordCount: wordCount,
    };
  }
  if (charCount >= 35 && charCount <= 65) {
    return {
      score: 100,
      percentage: 100,
      charCount: charCount,
      wordCount: wordCount,
    };
  }
};
